import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { NzResizeEvent } from 'ng-zorro-antd/resizable';
import { Column, Container } from '../dashboard';

@Component({
  selector: 'app-designer',
  templateUrl: './designer.component.html',
  styleUrls: ['./designer.component.less']
})
export class DesignerComponent implements OnInit {

  containers: Container[] = [];
  disableDrag = false;
  constructor() { }

  ngOnInit(): void {
  }

  addContainer() {
    console.log('add');
    this.containers.push({
      Id: (Math.random() * 10000).toFixed(0),
      Columns: []
    });
  }

  addColumn(container: Container) {
    container.Columns.push({
      Id: container.Columns.length + 1
    });
  }
  
  containersSorting(event: CdkDragDrop<Container[]>) {
    moveItemInArray(this.containers, event.previousIndex, event.currentIndex);
  }

  columnsSorting(container: Container, event: CdkDragDrop<Column[]>) {
    moveItemInArray(container.Columns, event.previousIndex, event.currentIndex);
  }

  resizeStart(event) {
    console.log('disable drag');
    this.disableDrag = true;
  }
  
  resizeStop(event) {
    console.log('enable drag');
    this.disableDrag = false;
  }

  onColumnResize(column: Column, { col }: NzResizeEvent): void {
    cancelAnimationFrame(column.Id);
    requestAnimationFrame(() => {
      column.CssClass = (col!).toString();
    });
  }  
}
